export interface SplitNarratorName {
  name: string;
  subtitle: string | null;
}

export function splitNarratorName(value: string | null | undefined): SplitNarratorName {
  const [rawName, ...rawSubtitleParts] = String(value ?? '').split('||');
  const name = rawName.trim();
  const subtitle = rawSubtitleParts.join('||').trim();

  return {
    name,
    subtitle: subtitle || null,
  };
}
